import type { TRouteObject } from "@ch/helpers/utils/types";
import ErrorPage from "@ch/pages/ErrorPage";
import NotFoundPage from "@ch/pages/NotFoundPage";
import NotificationsPageLazy from "@ch/pages/Notifications";

const NotificationRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <NotificationsPageLazy />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default NotificationRoutes;
